import { render, staticRenderFns } from "./UsuarioPage.vue?vue&type=template&id=e3af8892"
import script from "./UsuarioPage.vue?vue&type=script&lang=js"
export * from "./UsuarioPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports